export { PageVideosComponent as PageVideos } from './component';



// WEBPACK FOOTER //
// ./src/pages/videos/index.tsx